import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SystemSettingsService } from '../../services/system-settings/system-settings.service';
import { SystemSettingConfig } from '../../models/SystemSettingConfig';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent implements OnInit {
  @Input() UserName: string = "";
  baseUrl: string;
  url: string;

  loginDetails = new SystemSettingConfig();
  isDeskTop = true;

  constructor(private http: HttpClient, private logservice: SystemSettingsService, private router: Router, private responsive: BreakpointObserver) {
    this.baseUrl = environment.urlAddress + '/api/';

    //https://stackoverflow.com/questions/72945583/breakpointobserver-angular
    //https://www.geeksforgeeks.org/how-to-target-desktop-tablet-and-mobile-using-media-query/
    this.responsive.observe(['(min-width: 960px)','(max-width: 1279.99px)', '(min-width: 1280px)', Breakpoints.Web, Breakpoints.WebLandscape, Breakpoints.WebPortrait,
    Breakpoints.Tablet, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,
    Breakpoints.Handset, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
    Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge
    ])
      .subscribe(result => {

        const breakpoints = result.breakpoints;
        //console.log(breakpoints)

        //https://stackoverflow.com/questions/25393865/how-do-you-detect-between-a-desktop-and-mobile-chrome-user-agent/25394023#25394023
        //var ua = navigator.userAgent;
        //console.log(ua)
        //if (/Chrome/i.test(ua))
        //  console.log('mob')
        //else if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(ua))
        //  console.log('mob')
        //else
        //  console.log('desk')
        if (breakpoints[Breakpoints.Tablet] || breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]
          || breakpoints[Breakpoints.Handset] || breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]
          || breakpoints[Breakpoints.XSmall] || breakpoints[Breakpoints.Small]) {
          //console.log('mobile/ipad')
          this.isDeskTop = false;
          if ((breakpoints['(min-width: 960px)'] && breakpoints['(max-width: 1279.99px)']) || breakpoints['(min-width: 1280px)']) {
            //console.log('desktop')
            this.isDeskTop = true;
          }
        }
        else if (breakpoints[Breakpoints.Medium]) {
          //console.log('ipad pro')
          this.isDeskTop = false;
        }
        else {
          //console.log('desktop')
          this.isDeskTop = true;
        }
      });
  }

  ngOnInit() {
    this.GetSystemConfig();
  }

  disableConfig = false;
  GetSystemConfig() {
    this.url = this.baseUrl + 'UserAndSytemConfig/GetUserSystemConfiguration';

    this.GetConfigurations_Service().subscribe((res: any) => {
      //debugger;
      let rows: any[] = JSON.parse(res) as any[];

      let AdminName = rows["AdminName"];
      if (this.UserName !== AdminName)
        this.disableConfig = true;
    });
  }

  check() {
    const user_approval = window.confirm('Do you wish to logout?');
    if (!user_approval) {
      return false;
    } else {
      this.router.navigate(['/logout']);
    }
  }

  pdfFilePathNew = "/Webviewer/assets/DowloadedScripts/WebViewer-UM.pdf?v=6.4.20";//http://localhost:4200/assets/DowloadedScripts/WebViewer-UM.pdf?v=6.4.20


  OpenUM() {

    let pdfFilePath = '/Webviewer/assets/DowloadedScripts/WebViewer-UM.pdf?v=6.4.20';  //// '/Webviewer/assets/images/ITS/ITSHelp.pdf?v=6.4.20';

    //const pdfViewerUrl = `${pdfFilePath}#page=${83}`;  /// to open particular page number of pdf

    const windowFeatures = 'menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes,height = ' + screen.height * .66 + ',width=' + screen.width * .66;
    // Open the popup window
    //const popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    const popupWindow = window.open('', '_blank', windowFeatures);

    popupWindow.document.open();
    popupWindow.document.write(`
				<html>
					<head>
						<title>WebViewer User Manual</title>
						
            <body onload=""><iframe src="${pdfFilePath}" width="100%" height="100%"></iframe></body>
          </head>
        </html>
      `);
    ///// <body onload=""><iframe src="${pdfFilePath}" width="100%" height="100%"></iframe></body>
    ///<body onload=""><iframe src="${pdfViewerUrl}" width="100%" height="100%"></iframe></body> /// to open partiular page of pdf
    popupWindow.document.close();

    // Write the HTML content to the popup window
    //    popupWindow.document.write(`
    //  <html>
    //    <body>
    //      <iframe src="${pdfFilePath}" width="600" height="400"></iframe>      
    //    </body>
    //  </html>
    //`);

    //    // Make sure to close the document write operation
    //    popupWindow.document.close();

  }

  ChangePassword() {
    debugger;
    let logserviceObj;
    if (sessionStorage.getItem('SystemSettings') != null) {
      this.logservice = JSON.parse(sessionStorage.getItem('SystemSettings'));
    }
    else if (localStorage.getItem('SystemSettings') != null) {
      this.logservice = JSON.parse(localStorage.getItem('SystemSettings'));
    }

    if (this.logservice.UserName != null && this.logservice.UserName != "") {

      if (this.logservice.UserName.length <= 0) {
        alert("Session expired!!");
        this.router.navigateByUrl('/login');
      }
      this.loginDetails.UserName = this.logservice.UserName;//this.logservice.logDetail.split('@')[0];
      //this.loginDetails.Pin = this.logservice.logDetail.split('@')[1];
    }

    //this.router.navigateByUrl('login/Config?cp=1');
    //this.router.navigate([{ outlets: { ComponentOutlet: 'login/Config?cp=1', configPopup:null  } }]);
    //this.router.navigate([{ outlets: { popupOutlet: 'login/Config?cp=1' } }]);
    this.router.navigate(
      [
        {
          outlets: {
            popupOutlet: 'login/Config',
          },
        },
      ],
      {
        queryParams: {
          cp: '1',
        },
      }
    );


  }

  OpenExploreOptions() {
    debugger;
    
    //this.router.navigateByUrl('login/Config?cp=1');
    //this.router.navigate([{ outlets: { ComponentOutlet: 'login/Config?cp=1', configPopup:null  } }]);
   // this.router.navigate([{ outlets: { popupExploreOptions: 'help/exploreOptions' } }]);
    this.router.navigate(
      [
        {
          outlets: {
            popupExploreOptions: 'help/exploreOptions',
          },
        },
      ],
      {
        queryParams: {
          cp: '1',
        },
      }
    );

  }

  ////////////////////////////////////////////////////////  SERVICES
  GetConfigurations_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }
}
